// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3gPfZ","bigColWidth":"Table_bigColWidth__3VVX5","biggerColWidth":"Table_biggerColWidth__cw1Ce","row":"Table_row__32guI","col":"Table_col__2qZzW"};